var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"request-accreditation"},[_c('SpaceDescription',[_c('Headline',{attrs:{"size":1}},[_vm._v("Request accreditation")])],1),_c('Tabs',{attrs:{"tabs":_vm.tabs,"activeTab":_vm.activeTab}},[_c(_vm.activeTab,{tag:"component",on:{"tabchange":_vm.changeTab}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }